module.exports = __webpack_public_path__ + "static/media/d24ru.2ee8fffa.pdf";